import { combineReducers } from 'redux';
import {responsiveStateReducer} from 'redux-responsive'
import { v4 as uuidv4 } from 'uuid';

import {
  VENUE_SELECTED_CHANGED,
  EVENTS_CHANGED,
  CALENDAR_EVENT_CONFLICTS_CHANGED,
  OPEN_CALENDAR_EVENT_CONFLICTS_MODAL,
  CLOSE_CALENDAR_EVENT_CONFLICTS_MODAL,
  USER_UPDATED,
  CALENDAR_EVENT_CONFLICTS_MERGE_CHECKBOX_CLICKED,
  TOGGLE_ON_SALE_ENABLED,
  TOGGLE_PRE_SALE_ENABLED,
  TOGGLE_ARTIST_PRE_SALE_ENABLED,
  TOGGLE_ANNOUNCED_ENABLED,
  TOGGLE_CONFIRMED_ENABLED,
  TOGGLE_HOLDS_ENABLED,
  TOGGLE_PAST_EVENTS_ENABLED,
  TOGGLE_CANCELLED_EVENTS_ENABLED,
  DATA_TABLE_FILTERS_CHANGED,
  RELOAD_DATA_TABLE,
  DATA_TABLE_EL_CHANGED,
  SEARCH_TERM_CHANGED,
  CURRENT_TEAM_MEMBERSHIP_CHANGED,
  CHECK_AVAILS_IS_OPEN_CHANGED,
  CHECK_AVAILS_SETTINGS_CHANGED,
  CALENDAR_SYNC_IS_OPEN_CHANGED,
  CHECK_AVAILS_DATES_CHANGED,
  CHECK_AVAILS_CALENDAR_EVENTS_CHANGED,
  CHECK_AVAILS_LOADING_CHANGED,
  VENUE_OWNERSHIPS_CHANGED,
  ROOMS_CHANGED,
  ROOMS_REORDERED,
  HOLD_POSITIONS_REORDERED
} from '../constants/calendarViewV2Constants';

import {
  EVENT_TO_EDIT_UPDATE_SUCCESS,
  EVENT_TO_EDIT_DELETED
} from '../../EventForm/constants/eventFormConstants';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const user = (state = {}, action) => {
  switch (action.type) {
    case USER_UPDATED:
      return action.user;
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const venuesOptions = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const venueSelected = (state = {}, action) => {
  switch (action.type) {
    case VENUE_SELECTED_CHANGED:
      if (action.selected === null){
        return {};
      }

      var foundVenue = action.venues.find((venue) => {
        return venue.id === action.selected.value;
      })

      return Object.assign({}, foundVenue);
    default:
      return state;
  }
};

const events = (state = [], action) => {
  switch (action.type) {
    case EVENTS_CHANGED:
      return action.events;
    case EVENT_TO_EDIT_DELETED:
      return state.filter((event) => {
        return event.id !== action.event.id;
      });
    case HOLD_POSITIONS_REORDERED:
      return state.map((event) => {
        const newPosition = action.positionMapping[event.hold_position_id];
        if (newPosition !== undefined) {
          return { ...event, position: newPosition };
        }
        return event;
      });
    default:
      return state;
  }
};

const calendarEventConflicts = (state = [], action) => {
  switch (action.type) {
    case CALENDAR_EVENT_CONFLICTS_CHANGED:
      return action.calendarEventConflicts;
    case CALENDAR_EVENT_CONFLICTS_MERGE_CHECKBOX_CLICKED:
      return [...state].map((calendarEventConflict) => {
        if(calendarEventConflict.id === action.calendarEventConflict.id){
          return Object.assign({}, calendarEventConflict, {shouldMerge: action.checked});
        } else {
          return calendarEventConflict;
        }
      })
    default:
      return state;
  }
};

const calendarEventConflictsModalOpen = (state = false, action) => {
  switch (action.type) {
    case OPEN_CALENDAR_EVENT_CONFLICTS_MODAL:
      return true;
    case CLOSE_CALENDAR_EVENT_CONFLICTS_MODAL:
      return false;
    default:
      return state;
  }
};

const onSaleEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_ON_SALE_ENABLED:
      return action.onSaleEnabled;
    default:
      return state;
  }
};

const preSaleEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_PRE_SALE_ENABLED:
      return action.preSaleEnabled;
    default:
      return state;
  }
};

const artistPreSaleEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_ARTIST_PRE_SALE_ENABLED:
      return action.artistPreSaleEnabled;
    default:
      return state;
  }
};

const announcedEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_ANNOUNCED_ENABLED:
      return action.announcedEnabled;
    default:
      return state;
  }
};

const confirmedEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_CONFIRMED_ENABLED:
      return action.confirmedEnabled;
    default:
      return state;
  }
};

const holdsEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_HOLDS_ENABLED:
      return action.holdsEnabled;
    default:
      return state;
  }
};

const pastEventsEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_PAST_EVENTS_ENABLED:
      return action.pastEventsEnabled;
    default:
      return state;
  }
};

const cancelledEventsEnabled = (state = true, action) => {
  switch (action.type) {
    case TOGGLE_CANCELLED_EVENTS_ENABLED:
      return action.cancelledEventsEnabled;
    default:
      return state;
  }
};

const dataTableTitle = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableDataSource = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableOrder = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableColumns = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableEl = (state = {}, action) => {
  switch (action.type) {
    case DATA_TABLE_EL_CHANGED:
      return action.el;
    default:
      return state;
  }
};

const searchTerm = (state = "", action) => {
  switch (action.type) {
    case SEARCH_TERM_CHANGED:
      return action.term;
    default:
      return state;
  }
};

const dataTableFilters = (state = {}, action) => {
  switch (action.type) {
    case DATA_TABLE_FILTERS_CHANGED:
      return action.dataTableFilters;
    case TOGGLE_ON_SALE_ENABLED:
      return Object.assign({}, state, {show_on_sale: action.onSaleEnabled});
    case TOGGLE_PRE_SALE_ENABLED:
      return Object.assign({}, state, {show_pre_sale: action.preSaleEnabled});
    case TOGGLE_ARTIST_PRE_SALE_ENABLED:
      return Object.assign({}, state, {show_artist_pre_sale: action.artistPreSaleEnabled});
    case TOGGLE_ANNOUNCED_ENABLED:
      return Object.assign({}, state, {show_announced: action.announcedEnabled});
    case TOGGLE_CONFIRMED_ENABLED:
      return Object.assign({}, state, {show_confirmed: action.confirmedEnabled});
    case TOGGLE_HOLDS_ENABLED:
      return Object.assign({}, state, {show_holds: action.holdsEnabled});
    case TOGGLE_PAST_EVENTS_ENABLED:
      return Object.assign({}, state, {show_past: action.pastEventsEnabled});
    case TOGGLE_CANCELLED_EVENTS_ENABLED:
      return Object.assign({}, state, {show_cancelled: action.cancelledEventsEnabled});
    case RELOAD_DATA_TABLE:
      return Object.assign({}, state, {_changed: uuidv4()});
    default:
      return state;
  }
};

const currentTeamMembership = (state = {}, action) => {
  switch (action.type) {
    case CURRENT_TEAM_MEMBERSHIP_CHANGED:
      return action.currentTeamMembership;
    case SEARCH_TERM_CHANGED:
      return {
        ...state,
        calendar_view: "list"
      };
    default:
      return state;
  }
};

const venueOwnerships = (state = [], action) => {
  switch (action.type) {
    case VENUE_OWNERSHIPS_CHANGED:
      return action.venueOwnerships;
    default:
      return state;
  }
};

const checkAvailsIsOpen = (state = false, action) => {
  switch (action.type) {
    case CHECK_AVAILS_IS_OPEN_CHANGED:
      return action.checkAvailsIsOpen;
    default:
      return state;
  }
};

var defaultCheckAvailsSettings = {
  noConfirms: true,
  noHolds: true,
  onDaysOfWeek: [0, 1, 2, 3, 4, 5, 6],
  roomId: null
}

const checkAvailsSettings = (state = defaultCheckAvailsSettings, action) => {
  switch (action.type) {
    case CHECK_AVAILS_SETTINGS_CHANGED:
      return action.checkAvailsSettings;
    default:
      return state;
  }
};

const checkAvailsDates = (state = [], action) => {
  switch (action.type) {
    case CHECK_AVAILS_DATES_CHANGED:
      return action.checkAvailsDates;
    default:
      return state;
  }
};

const checkAvailsCalendarEvents = (state = null, action) => {
  switch (action.type) {
    case CHECK_AVAILS_CALENDAR_EVENTS_CHANGED:
      return action.checkAvailsCalendarEvents;
    default:
      return state;
  }
};

const checkAvailsLoading = (state = false, action) => {
  switch (action.type) {
    case CHECK_AVAILS_LOADING_CHANGED:
      return action.checkAvailsLoading;
    default:
      return state;
  }
};

const calendarSyncIsOpen = (state = false, action) => {
  switch (action.type) {
    case CALENDAR_SYNC_IS_OPEN_CHANGED:
      return action.calendarSyncIsOpen;
    default:
      return state;
  }
};

const canCompTickets = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const conductorEnabled = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const canReadHoldChallenges = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const canManageHoldChallenges = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const rooms = (state = [], action) => {
  switch (action.type) {
    case ROOMS_CHANGED:
      return action.rooms;
    case ROOMS_REORDERED:
      return action.rooms;
    default:
      return state;
  }
};

const calendarViewV2Reducer = combineReducers({
  csrfToken,
  user,
  team,
  events,
  venuesOptions,
  venueSelected,
  browser: responsiveStateReducer,
  calendarEventConflicts,
  calendarEventConflictsModalOpen,
  onSaleEnabled,
  preSaleEnabled,
  artistPreSaleEnabled,
  announcedEnabled,
  confirmedEnabled,
  holdsEnabled,
  pastEventsEnabled,
  cancelledEventsEnabled,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  dataTableFilters,
  dataTableEl,
  searchTerm,
  currentTeamMembership,
  venueOwnerships,
  checkAvailsIsOpen,
  checkAvailsSettings,
  calendarSyncIsOpen,
  checkAvailsDates,
  checkAvailsCalendarEvents,
  checkAvailsLoading,
  rooms,
  canCompTickets,
  conductorEnabled,
  canReadHoldChallenges,
  canManageHoldChallenges
});

export default calendarViewV2Reducer;
